export default __webpack_public_path__ + "static/media/logotipo-trampare.a195abfd.png";